import React from 'react';
import { Link } from 'react-router-dom';

const AuthActions = () => {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <Link
          to="/forgot-password"
          className="text-sm text-primary hover:text-primary/80 transition-colors font-medium"
        >
          Forgot your password?
        </Link>
      </div>

      <div className="text-center text-sm text-muted-foreground">
        Don't have an account?{' '}
        <Link
          to="/register"
          className="text-primary hover:text-primary/80 transition-colors font-medium"
        >
          Create Account
        </Link>
      </div>
    </div>
  );
};

export default AuthActions;